/*Macle 24.9.0 jssdk v0.0.16  Sun Sep 29 2024*/
!(function (e, t) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = t())
    : "function" == typeof define && define.amd
    ? define(t)
    : ((e = "undefined" != typeof globalThis ? globalThis : e || self).jssdk =
        t());
})(this, function () {
  var e, t;
  const n =
      null ===
        (t =
          null ===
            (e =
              null === window || void 0 === window
                ? void 0
                : window.navigator) || void 0 === e
            ? void 0
            : e.userAgent) || void 0 === t
        ? void 0
        : t.toLocaleLowerCase(),
    r = -1 !== (null == n ? void 0 : n.indexOf("android")),
    i = Symbol("currentRoute"),
    o = Symbol("isInitd"),
    a = Symbol("tabBar"),
    s = Symbol("canNavigateTo"),
    c = "__ma__global__",
    u = { [i]: "", [o]: !1, [a]: null, [s]: !0 };
  function l(e, t) {
    u[e] = t;
  }
  function E(e) {
    return window[c][e];
  }
  window[c] = u;
  const d = {
      MiniProgram: {
        NAVIGATE_TO: "navigateTo",
        NAVIGATE_BACK: "navigateBack",
        REDIRECT_TO: "redirectTo",
        SWITCH_TAB: "switchTab",
        RE_LAUNCH: "reLaunch",
        POST_MESSAGE: "postMessage",
        CLOSE: "close",
      },
      Native: {
        CHOOSE_VIDEO: "chooseVideo",
        CHOOSE_IMAGE: "chooseImage",
        GET_LOCAL_IMG_DATA: "getLocalImgData",
        GET_LOCATION: "getLocation",
        PREVIEW_IMAGE: "previewImage",
        OPEN_DOCUMENT: "openDocument",
        GET_STORAGE: "getStorage",
        SET_STORAGE: "setStorage",
        GET_STORAGE_SYNC: "getStorageSync",
        SET_STORAGE_SYNC: "setStorageSync",
        REMOVE_STORAGE: "removeStorage",
        CLEAR_STORAGE: "clearStorage",
        GET_NETWORK_TYPE: "getNetworkType",
        SCAN_CODE: "scanCode",
        GET_STATUS_BAR_HEIGHT: "getStatusBarHeight",
        CAPSULE_STYLE: "capsuleStyle",
        HIDE_LOADING: "hideLoading",
        SHOW_LOADING: "showLoading",
        SHOW_TOAST: "showToast",
        GET_SMALL_APP_INFO: "getsmallappinfo",
        GO_TO_BROWSER: "gotoBrowser",
        SAVE_FILE_TO_PHONE: "saveFileToPhone",
        SAVE_IMAGE: "saveImage",
        SAVE_BASE64_IMAGE: "saveBase64Image",
        CHOOSE_CONTACT: "chooseContact",
        IS_ONLINE: "isOnline",
        REQUEST: "request",
        UPLOAD_FILE: "uploadFile",
        DOWNLOAD_FILE: "downloadFile",
        REPORT_EVENT: "reportEvent",
        REPORT_PERFORMANCE: "reportPerformance",
        REPORT_LOG: "reportLog",
        SUBMIT_REPORT: "submitReport",
        PLAY_VOICE: "playVoice",
        PLAY_AUDIO: "playAudio",
        GET_BACKGROUND_FETCH_DATA: "getBackgroundFetchData",
        GET_LAUNCH_OPTIONS_SYNC: "getLaunchOptionsSync",
        GET_SYSTEM_INFO_SYNC: "getSystemInfoSync",
        NAVIGATE_TO_MINI_PROGRAM: "navigateToMiniProgram",
        EXIT_MINI_PROGRAM: "exitMiniProgram",
        STOP_AUOID: "stopVoice",
        GET_OPEN_USER_INFO: "getOpenUserInfo",
        GET_AUTH_CODE: "getAuthCode",
        OPEN_BLUETOOTH_ADAPTER: "openBluetoothAdapter",
        CLOSE_BLUETOOTH_ADAPTER: "closeBluetoothAdapter",
        START_BLUETOOTH_DEVICES_DISCOVERY: "startBluetoothDevicesDiscovery",
        STOP_BLUETOOTH_DEVICES_DISCOVERY: "stopBluetoothDevicesDiscovery",
        CREATE_BLE_CONNECTION: "createBLEConnection",
        CLOSE_BLE_CONNECTION: "closeBLEConnection",
        GET_BLE_DEVICE_SERVICES: "getBLEDeviceServices",
        GET_BLE_DEVICE_CHARACTERISTICS: "getBLEDeviceCharacteristics",
        READ_BLE_CHARACTERISTIC_VALUE: "readBLECharacteristicValue",
        WRITE_BLE_CHARACTERISTIC_VALUE: "writeBLECharacteristicValue",
        ON_BLUETOOTH_DEVICE_FOUND: "ON_BT_DEVICE_FOUND",
        OFF_BLUETOOTH_DEVICE_FOUND: "offBluetoothDeviceFound",
        ON_SCREEN_RECORD_STATE_CHANGE: "ON_SCREEN_RECORD_STATE_CHANGE",
        ON_SCREEN_RECORD_STATE_CHANGED: "onScreenRecordingStateChanged",
        OFF_SCREEN_RECORDING_STATE_CHANGED: "offScreenRecordingStateChanged",
        TRADE_PAY: "tradePay",
        DEAUTHORIZE_PERMISSION: "deauthorize",
        CANCLE_AUTHORIZE_PERMISSION: "cancelAuthorize",
      },
    },
    f = void 0 !== window.parent.__simulatorConfig__;
  const v = new (class {
      constructor() {
        (this.eventMap = new Map()), (this.callbackMap = new Map());
      }
      on(e, t) {
        var n;
        const r = function (...e) {
          try {
            t.apply(void 0, e);
          } catch (e) {
            console.error(e);
          }
        };
        this.callbackMap.set(t, r),
          this.eventMap.has(e)
            ? null === (n = this.eventMap.get(e)) || void 0 === n || n.add(r)
            : this.eventMap.set(e, new Set([r]));
      }
      off(e, t) {
        const n = this.eventMap.get(e);
        if (n)
          if (t) {
            const e = this.callbackMap.get(t);
            n.delete(e);
          } else n.clear();
      }
      get(e) {
        return this.eventMap.get(e);
      }
      emit(e, t) {
        const n = this.eventMap.get(e);
        if (n) for (const e of n) e.call(this, t);
      }
    })(),
    _ = {};
  let O = 0;
  const N = {};
  function T(e, t = {}, n) {
    const i = JSON.stringify(t),
      o = ++O;
    (_[o] = n),
      (function (e, t, n) {
        f
          ? window?.simulatorWebkit?.messageHandlers?.invoke?.postMessage({
              command: e,
              inputParams: t,
              callbackId: n,
              type: "legacy",
            })
          : r
          ? window?.viewLayerNative?.invoke(e, t, n)
          : window?.webkit?.messageHandlers?.invoke?.postMessage({
              command: e,
              inputParams: t,
              callbackId: n,
            });
      })(e, i, o);
  }
  function p(e, t) {
    const n = JSON.stringify(Object.assign({ command: e }, t));
    return window.prompt(n);
  }
  function m(e, t, n = {}) {
    const r = {};
    for (const e in t)
      "function" == typeof t[e] && ((r[e] = t[e]), delete t[e]);
    T(e, t, (e, t) => {
      var i, o, a, s, c, u, l, E, d, f, v;
      const _ = 0 === Number(e),
        O = [1, -1].includes(Number(e));
      _
        ? (null === (i = null == n ? void 0 : n.beforeAll) ||
            void 0 === i ||
            i.call(n, t),
          null === (o = null == n ? void 0 : n.beforeSuccess) ||
            void 0 === o ||
            o.call(n, t),
          null === (a = r.success) || void 0 === a || a.call(r, t),
          null === (s = null == n ? void 0 : n.afterSuccess) ||
            void 0 === s ||
            s.call(n, t))
        : O
        ? (null === (c = null == n ? void 0 : n.beforeFail) ||
            void 0 === c ||
            c.call(n, t),
          null === (u = r.fail) || void 0 === u || u.call(r, t),
          null === (l = null == n ? void 0 : n.afterFail) ||
            void 0 === l ||
            l.call(n, t))
        : (null === (E = null == n ? void 0 : n.beforeSuccess) ||
            void 0 === E ||
            E.call(n, t),
          null === (d = null == r ? void 0 : r.preload) ||
            void 0 === d ||
            d.call(r, t)),
        (_ || O) &&
          (null === (f = r.complete) || void 0 === f || f.call(r, t),
          null === (v = null == n ? void 0 : n.afterAll) ||
            void 0 === v ||
            v.call(n, t));
    });
  }
  function I(e, t = {}) {
    const n = JSON.stringify(t);
    f
      ? window?.simulatorWebkit?.messageHandlers?.notifyNative?.postMessage({
          command: e,
          inputParams: n,
          type: "legacy",
        })
      : r
      ? window?.viewLayerNative?.notifyNative(e, n)
      : window?.webkit?.messageHandlers?.notifyNative?.postMessage({
          command: e,
          inputParams: n,
        });
  }
  function S(e, t) {
    N[e] = t;
  }
  const A = {
    invoke: T,
    invokeMethod: m,
    notifyNative: I,
    invokeSync: p,
    onNativeNotify: function (e, t, n) {
      !(function (e, t, n) {
        "function" == typeof e && e(n, t || n.webviewId || "");
      })(N[e], t, n);
    },
    onBasicEvent: S,
    offBasicEvent: function (e) {
      N[e] = void 0;
    },
  };
  window.logicLayer = A;
  const g = {},
    C = "ma_custom_event_";
  function b(e, t) {
    g[`${C}${e}`] = t;
  }
  function R(e, t = {}) {
    const n = JSON.stringify(t);
    h(`${C}${e}`, n);
  }
  function h(e, t) {
    f
      ? window?.simulatorWebkit?.messageHandlers?.notifyNative?.postMessage({
          eventName: e,
          paramsString: t,
          type: "legacy",
        })
      : r
      ? window?.viewLayerNative?.notifyNative(e, t)
      : window?.webkit?.messageHandlers?.notifyNative?.postMessage({
          eventName: e,
          paramsString: t,
        });
  }
  const L = {
    invoke: T,
    invokeSync: p,
    invokeMethod: m,
    beforeInvoke: function (e, t = {}, n = {}) {
      return t.success || t.fail || t.complete
        ? m(e, t, n)
        : new Promise((r, i) => {
            (t.success = r), (t.fail = i), m(e, t, n);
          });
    },
    notifyNative: I,
    subscribe: b,
    webSubscribe: function (e, t) {
      g[e] = t;
    },
    publish: R,
    webPublish: function (e, t = {}) {
      h(e, JSON.stringify(t));
    },
    onBasicEvent: S,
  };
  function P() {
    if (!E(o)) {
      l(o, !0);
      try {
        L.onBasicEvent(d.Native.ON_BLUETOOTH_DEVICE_FOUND, function (e) {
          v.emit(d.Native.ON_BLUETOOTH_DEVICE_FOUND, e);
        }),
          L.onBasicEvent(d.Native.ON_SCREEN_RECORD_STATE_CHANGE, function (e) {
            v.emit(d.Native.ON_SCREEN_RECORD_STATE_CHANGE, e);
          }),
          b("getCurrentRoute", (e) => {
            l(i, e.route),
              l(a, e.tabBar),
              l(s, void 0 === e.canNavigateTo || e.canNavigateTo);
          }),
          R("getCurrentRoute");
      } catch (e) {}
    }
  }
  class y extends Error {
    constructor(e, t) {
      if (
        (super(`${e} fail, ${t}`),
        (this.fileName = ""),
        (this.lineNumber = 1),
        (this.columnNumber = -1),
        (this.name = this.constructor.name),
        !this.stack)
      )
        return;
      const [, n, r = 1, i] =
        this.stack.match(/\/([\/\w-_\.]+\.js):(\d*):(\d*)/) || [];
      (this.fileName = n),
        (this.lineNumber = Number(r)),
        (this.columnNumber = Number(i));
    }
  }
  const D = "MACLE_ERROR_LOG",
    U = {
      normalError(e) {
        console.error(null == e ? void 0 : e.message),
          I(D, {
            key: e.key || "MacleApiError",
            errorStack: e.message,
            apiName: e.apiName,
            keywords: e.keywords,
            fwkVersion: "",
            file: e.file,
            line: e.line,
            column: e.column,
            timestamp: Date.now(),
          });
      },
    };
  function G(e, t, n = !0) {
    let r,
      i,
      o = t;
    if (
      (n &&
        (o = (function (e) {
          const t = e.split("?");
          return (t[0] += ".html"), void 0 === t[1] ? t[0] : `${t[0]}?${t[1]}`;
        })(o)),
      o.startsWith("/"))
    )
      return o.substr(1);
    if (o.startsWith("./")) return G(e, o.substr(2), !1);
    const a = o.split("/");
    for (r = 0, i = a.length; r < i && ".." === a[r]; r++);
    a.splice(0, r);
    const s = e.length > 0 ? e.split("/") : [];
    return s.splice(s.length - r - 1, r + 1), s.concat(a).join("/");
  }
  function k(e) {
    const t = e.split("?"),
      [n, r] = t;
    if (!r) return e;
    const i = r.split("&").reduce((e, t) => {
        if ("string" == typeof t && t.length > 0) {
          const n = t.split("="),
            r = n[0],
            i = n[1];
          e[r] = i;
        }
        return e;
      }, Object.create(null)),
      o = [];
    for (const e in i) o.push(e + "=" + encodeURIComponent(i[e]));
    return o.length > 0 ? n + "?" + o.join("&") : e;
  }
  function M(e, t) {
    const n = E(a);
    if (null === n) return !0;
    t.url.startsWith("/") && (t.url = t.url.slice(1));
    const r =
      ((i = t.url),
      null == n ? void 0 : n.list.find((e) => 0 === i.indexOf(e.pagePath)));
    var i;
    return (e !== d.MiniProgram.NAVIGATE_TO &&
      e !== d.MiniProgram.REDIRECT_TO) ||
      !r
      ? !(e === d.MiniProgram.SWITCH_TAB && !r) ||
          (w(e, `${e}: can not ${e} to a non-tabbar page`), !1)
      : (w(e, `${e}: can not ${e} to a tabbar page`), !1);
  }
  function B(e) {
    return /^(http|https):\/\/.*/i.test(e);
  }
  function H(e) {
    return Object.prototype.toString.call(e).split(" ")[1].split("]")[0];
  }
  function w(e, t) {
    const n = new y(e, t);
    return (
      U.normalError({
        message: n.message,
        file: n.fileName,
        line: n.lineNumber,
        column: n.columnNumber,
      }),
      n
    );
  }
  function V(e, t) {
    if (F(e) && $(t) && Object.keys(t).length) {
      const n = e.split("?")[0],
        r = e.split("?")[1],
        i = {};
      r &&
        r.split("&").forEach((e) => {
          e.length && (i[e.split("=")[0]] = e.split("=")[1]);
        });
      const o = {};
      for (const [e, n] of Object.entries(t))
        $(n) ? (o[e] = JSON.stringify(n)) : (o[e] = n);
      return `${n}?${(function (e) {
        if (!$(e)) return e;
        const t = [];
        for (const n in e)
          try {
            t.push(`${encodeURIComponent(n)}=${encodeURIComponent(e[n])}`);
          } catch (r) {
            t.push(`${n}=${e[n]}`);
          }
        return t.join("&");
      })(
        (function (e, t) {
          for (const [n, r] of Object.entries(t)) e[n] = r;
          return e;
        })(i, o),
      )}`;
    }
    return e;
  }
  function j(e) {
    return "Array" === H(e);
  }
  function F(e) {
    return "String" === H(e);
  }
  function $(e) {
    return "Object" === H(e);
  }
  function W(e) {
    return "Number" === H(e);
  }
  function Y(e, t, n) {
    var r;
    const i = w(e, n);
    if (!t.success && !t.fail && !t.complete)
      return new Promise((e, n) => {
        (t.fail = n), t.fail({ errMsg: i.message });
      });
    for (const e of ["fail", "complete"]) {
      null === (r = t[e]) || void 0 === r || r.call(t, { errMsg: i.message });
    }
    return null;
  }
  function x(e, t, n, r = "parameter", i = !1) {
    let o = "";
    const a = H(t),
      s = H(n);
    if (a !== s)
      return (
        (o = `${r} should be ${s} instead of ${a};`),
        (t.invalidParamObj = Y(e, t, o)),
        !1
      );
    if ("Object" !== s) return !0;
    for (const [e, r] of Object.entries(n))
      if (Object.prototype.hasOwnProperty.call(t, e) || i) {
        const n = H(r),
          i = H(t[e]);
        n !== i && (o += `${e} should be ${n} instead of ${i};`);
      }
    return !o || ((t.invalidParamObj = Y(e, t, o)), !1);
  }
  function J(e, t, n, r = {}, i = "parameter") {
    const o = (function (e, t, n = {}) {
      var r;
      const i = Object.assign({}, t);
      for (let o in t)
        void 0 === e[o] &&
          (null === (r = n[o]) || void 0 === r ? void 0 : r.optional) &&
          (delete i[o], delete n[o]);
      return i;
    })(t, n, r);
    return (
      !!x(e, t, o, i, !0) &&
      (function (e, t, n, r = {}, i = "parameter") {
        let o = "";
        for (let e in r) {
          const i = t[e],
            a = n[e],
            { range: s, checkSubEleType: c, nonempty: u } = r[e];
          u && (o += z(e, i)),
            c && (o += K(e, i, a)),
            (null == s ? void 0 : s.length) && (o += Z(e, i, s));
        }
        if (o) return (t.invalidParamObj = Y(e, t, o)), !1;
        return !0;
      })(e, t, o, r, i)
    );
  }
  function z(e, t) {
    const n = j(t) && !t.length,
      r = F(t) && !t.trim();
    return n || r ? `parameter error: ${e} cannot be empty;` : "";
  }
  function K(e, t, n) {
    let r = "";
    if (j(t)) {
      const i = n.map((e) => H(e)),
        o = t.filter((e) => !i.includes(H(e)));
      o.length &&
        (r += `parameter error: invalid ${e} ${o}, the sub-element type of ${e} should be ${i.join(
          " or ",
        )};`);
    }
    if ($(t))
      for (const i in n) {
        const o = H(t[i]),
          a = H(n[i]);
        o !== a &&
          (r += `parameter error: ${e}.${i} should be ${a} instead of ${o};`);
      }
    return r;
  }
  function Z(e, t, n) {
    const r = (j(t) ? t : [t]).filter((e) => !n.includes(e));
    return r.length ? `parameter error: invalid ${e} ${r};` : "";
  }
  const q = [
      "AUTH_BASE",
      "AUTH_USER",
      "SEND_MESSAGE",
      "USER_NICKNAME",
      "USER_NAME",
      "USER_LOGIN_ID",
      "PLAINTEXT_USER_LOGIN_ID",
      "HASH_LOGIN_ID",
      "USER_AVATAR",
      "USER_GENDER",
      "USER_BIRTHDAY",
      "USER_NATIONALITY",
      "USER_CONTACTINFO",
      "USER_ADDRESS",
      "PLAINTEXT_MOBILE_PHONE",
    ],
    X = [
      "location",
      "camera",
      "photosAlbums",
      "contacts",
      "record",
      "jumpMiniApp",
      "gotoBrowser",
      "bluetooth",
      "payment",
      "video",
      "storage",
    ];
  function Q(e, t, n) {
    for (const [r, i] of Object.entries(e))
      if (!i || ("string" == typeof i && 0 === i.trim().length))
        return (
          (t.invalidParamObj = Y(
            n,
            t,
            `parameter error: ${r} should be required instead of Undefined or empty.`,
          )),
          !1
        );
    return !0;
  }
  var ee = Object.freeze({
    __proto__: null,
    close: function () {
      L.invokeMethod(d.MiniProgram.CLOSE);
    },
    getEnv: function (e) {
      e({ miniprogram: "miniprogram" === window.__ma_environment });
    },
    navigateBack: function (e) {
      const t = Object.assign({ delta: 1 }, e);
      L.beforeInvoke(d.MiniProgram.NAVIGATE_BACK, t);
    },
    navigateTo: function (e) {
      if (!e.url)
        return Y(
          d.MiniProgram.NAVIGATE_TO,
          e,
          "parameter error:parameter.url should be String instead of Undefined.",
        );
      const t = e;
      (t.url = G(E(i), t.url)),
        (t.url = k(t.url)),
        M(d.MiniProgram.NAVIGATE_TO, t) &&
          L.beforeInvoke(d.MiniProgram.NAVIGATE_TO, t);
    },
    postMessage: function (e) {
      L.beforeInvoke(d.MiniProgram.POST_MESSAGE, e);
    },
    reLaunch: function (e) {
      if (!e.url)
        return Y(
          d.MiniProgram.RE_LAUNCH,
          e,
          "parameter error:parameter.url should be String instead of Undefined.",
        );
      const t = e;
      (t.url = G(E(i), t.url)),
        (t.url = k(t.url)),
        M(d.MiniProgram.RE_LAUNCH, t) &&
          L.beforeInvoke(d.MiniProgram.RE_LAUNCH, t);
    },
    redirectTo: function (e) {
      if (!e.url)
        return Y(
          d.MiniProgram.REDIRECT_TO,
          e,
          "parameter error:parameter.url should be String instead of Undefined.",
        );
      const t = e;
      (t.url = G(E(i), t.url)),
        (t.url = k(t.url)),
        M(d.MiniProgram.REDIRECT_TO, t) &&
          L.beforeInvoke(d.MiniProgram.REDIRECT_TO, t);
    },
    switchTab: function (e) {
      if (!e.url)
        return Y(
          d.MiniProgram.SWITCH_TAB,
          e,
          "parameter error:parameter.url should be String instead of Undefined.",
        );
      const t = e;
      (t.url = G(E(i), t.url)),
        (t.url = k(t.url)),
        M(d.MiniProgram.SWITCH_TAB, t) &&
          L.beforeInvoke(d.MiniProgram.SWITCH_TAB, t);
    },
  });
  function te() {}
  const ne = { nonempty: !0 },
    re = { optional: !0 };
  const ie = { optional: !0 };
  const oe = { nonempty: !0 },
    ae = { optional: !0 };
  var se = Object.freeze({
    __proto__: null,
    callNativeAPI: function (e, t = {}, n, r = te) {
      [n, r].find((e) => !e || "function" != typeof e)
        ? w(e, "callback should be function!")
        : L.invoke(e, t, (t, i) => {
            if (!(0 === Number(t))) return w(e, `${i.errMsg}`), void r(i);
            n(i);
          });
    },
    cancelAuthorize: function (e) {
      if (!e.scopes)
        return Y(
          d.Native.CANCLE_AUTHORIZE_PERMISSION,
          e,
          "parameter error:parameter.scopes should be Array<string> instead of Undefined.",
        );
      if (J(d.Native.CANCLE_AUTHORIZE_PERMISSION, e, { scopes: [""] })) {
        const t = (function (e) {
          const t = [...X, ...q].map((e) => `scope.${e}`);
          return e.filter((e) => !t.includes(`${e}`));
        })(e.scopes);
        return t.length > 0
          ? Y(
              d.Native.CANCLE_AUTHORIZE_PERMISSION,
              e,
              `parameter error: invalid scopes ${t}`,
            )
          : L.beforeInvoke(d.Native.CANCLE_AUTHORIZE_PERMISSION, e);
      }
      return e.invalidParamObj;
    },
    capsuleStyle: function (e) {
      if (x(d.Native.CAPSULE_STYLE, e, { style: 0 })) {
        return -1 === [0, 1].indexOf(e.style)
          ? Y(
              d.Native.CAPSULE_STYLE,
              e,
              `parameter error: invalid style ${e.style}`,
            )
          : L.beforeInvoke(d.Native.CAPSULE_STYLE, e);
      }
      return e.invalidParamObj;
    },
    chooseContact: function (e) {
      return L.beforeInvoke(d.Native.CHOOSE_CONTACT, e);
    },
    chooseImage: function (e) {
      if (
        J(
          d.Native.CHOOSE_IMAGE,
          e,
          { sourceType: [""], sizeType: [""] },
          {
            sourceType: {
              optional: !0,
              checkSubEleType: !0,
              range: ["album", "camera"],
            },
            sizeType: { optional: !0, range: ["original", "compressed"] },
          },
        )
      ) {
        const t = Object.assign(
          {
            count: 9,
            sizeType: ["original", "compressed"],
            sourceType: ["album", "camera"],
          },
          e,
        );
        return L.beforeInvoke(d.Native.CHOOSE_IMAGE, t);
      }
      return e.invalidParamObj;
    },
    chooseVideo: function (e) {
      if (
        J(
          d.Native.CHOOSE_VIDEO,
          e,
          { sourceType: [""], camera: "" },
          {
            sourceType: {
              optional: !0,
              checkSubEleType: !0,
              range: ["album", "camera"],
            },
            camera: { optional: !0, range: ["back", "front"] },
          },
        )
      ) {
        const t = Object.assign(
          { sourceType: ["album", "camera"], camera: "back" },
          e,
        );
        return L.beforeInvoke(d.Native.CHOOSE_VIDEO, t);
      }
      return e.invalidParamObj;
    },
    clearStorage: function (e) {
      return L.beforeInvoke(d.Native.CLEAR_STORAGE, e);
    },
    closeBLEConnection: function (e) {
      return Q({ deviceId: e.deviceId }, e, d.Native.CLOSE_BLE_CONNECTION) &&
        x(d.Native.CLOSE_BLE_CONNECTION, e, { deviceId: "" })
        ? L.beforeInvoke(d.Native.CLOSE_BLE_CONNECTION, e)
        : e.invalidParamObj;
    },
    closeBluetoothAdapter: function (e) {
      return L.beforeInvoke(d.Native.CLOSE_BLUETOOTH_ADAPTER, e);
    },
    createBLEConnection: function (e) {
      if (!Q({ deviceId: e.deviceId }, e, d.Native.CREATE_BLE_CONNECTION))
        return e.invalidParamObj;
      if (
        J(
          d.Native.CREATE_BLE_CONNECTION,
          e,
          { deviceId: "", timeout: 0 },
          { timeout: { optional: !0 } },
        )
      ) {
        const t = Object.assign({ timeout: 3e4 }, e);
        return L.beforeInvoke(d.Native.CREATE_BLE_CONNECTION, t);
      }
      return e.invalidParamObj;
    },
    deauthorize: function (e) {
      return L.beforeInvoke(d.Native.DEAUTHORIZE_PERMISSION, e);
    },
    downloadFile: function (e) {
      return e.url
        ? B(e.url)
          ? L.beforeInvoke(d.Native.DOWNLOAD_FILE, e)
          : Y(
              d.Native.DOWNLOAD_FILE,
              e,
              `parameter error: invalid url ${e.url}`,
            )
        : Y(
            d.Native.DOWNLOAD_FILE,
            e,
            "parameter error: parameter.url should be String instead of Undefined.",
          );
    },
    exitMiniProgram: function (e) {
      return J(
        d.Native.EXIT_MINI_PROGRAM,
        e,
        { clearCache: !1 },
        { clearCache: ie },
      )
        ? L.beforeInvoke(d.Native.EXIT_MINI_PROGRAM, e)
        : e.invalidParamObj;
    },
    getAuthCode: function (e) {
      if (!e.scopes)
        return Y(
          d.Native.GET_AUTH_CODE,
          e,
          "parameter error:parameter.scopes should be Array<string> instead of Undefined.",
        );
      if (x(d.Native.GET_AUTH_CODE, e, { scopes: ["1"] })) {
        const t = e.scopes.filter((e) => !q.includes(`${e}`.toUpperCase()));
        return t.length > 0
          ? Y(d.Native.GET_AUTH_CODE, e, `parameter error: invalid scopes ${t}`)
          : L.beforeInvoke(d.Native.GET_AUTH_CODE, e);
      }
      return e.invalidParamObj;
    },
    getBLEDeviceCharacteristics: function (e) {
      return Q(
        { deviceId: e.deviceId, serviceId: e.serviceId },
        e,
        d.Native.GET_BLE_DEVICE_CHARACTERISTICS,
      ) &&
        x(d.Native.GET_BLE_DEVICE_CHARACTERISTICS, e, {
          deviceId: "",
          serviceId: "",
        })
        ? L.beforeInvoke(d.Native.GET_BLE_DEVICE_CHARACTERISTICS, e)
        : e.invalidParamObj;
    },
    getBLEDeviceServices: function (e) {
      return Q({ deviceId: e.deviceId }, e, d.Native.GET_BLE_DEVICE_SERVICES) &&
        x(d.Native.GET_BLE_DEVICE_SERVICES, e, { deviceId: "" })
        ? L.beforeInvoke(d.Native.GET_BLE_DEVICE_SERVICES, e)
        : e.invalidParamObj;
    },
    getBackgroundFetchData: function (e) {
      return e.fetchType
        ? L.beforeInvoke(d.Native.GET_BACKGROUND_FETCH_DATA, e)
        : Y(
            d.Native.GET_BACKGROUND_FETCH_DATA,
            e,
            "parameter error:parameter.fetchType should be string instead of Undefined.",
          );
    },
    getLaunchOptionsSync: function () {
      const e = L.invokeSync(d.Native.GET_LAUNCH_OPTIONS_SYNC);
      return e && JSON.parse(e);
    },
    getLocalImgData: function (e) {
      return (null == e ? void 0 : e.path)
        ? L.beforeInvoke(d.Native.GET_LOCAL_IMG_DATA, e)
        : Y(
            d.Native.GET_LOCAL_IMG_DATA,
            e,
            "parameter error:parameter.path should be String instead of Undefined.",
          );
    },
    getLocation: function (e) {
      const t = Object.assign({ useFetchData: !1 }, e);
      return L.beforeInvoke(d.Native.GET_LOCATION, t);
    },
    getNetworkType: function (e) {
      return L.beforeInvoke(d.Native.GET_NETWORK_TYPE, e);
    },
    getOpenUserInfo: function (e) {
      return L.beforeInvoke(d.Native.GET_OPEN_USER_INFO, e);
    },
    getStatusBarHeight: function (e) {
      return L.beforeInvoke(d.Native.GET_STATUS_BAR_HEIGHT, e);
    },
    getStorage: function (e) {
      if (!(null == e ? void 0 : e.key))
        return Y(
          d.Native.GET_STORAGE,
          e,
          "parameter error:parameters.key should be String instead of Undefined.",
        );
      const t = Object.assign({ encrypt: !1 }, e);
      return L.beforeInvoke(d.Native.GET_STORAGE, t);
    },
    getStorageSync: function (e) {
      return "String" !== H(e)
        ? Y(
            d.Native.GET_STORAGE_SYNC,
            {},
            `parameter error:key should be string instead of ${typeof e}.`,
          )
        : L.invokeSync(d.Native.GET_STORAGE_SYNC, { key: e });
    },
    getSystemInfoSync: function () {
      const e = L.invokeSync(d.Native.GET_SYSTEM_INFO_SYNC);
      return e && JSON.parse(e);
    },
    getsmallappinfo: function (e) {
      return L.beforeInvoke(d.Native.GET_SMALL_APP_INFO, e);
    },
    gotoBrowser: function (e) {
      return e.openUrl
        ? x(d.Native.GO_TO_BROWSER, e, { openUrl: "" })
          ? L.beforeInvoke(d.Native.GO_TO_BROWSER, e)
          : e.invalidParamObj
        : Y(
            d.Native.GO_TO_BROWSER,
            e,
            "parameter error:parameter.openUrl should be String instead of Undefined.",
          );
    },
    hideLoading: function (e) {
      return L.beforeInvoke(d.Native.HIDE_LOADING, e);
    },
    isOnline: function () {
      return window.navigator.onLine;
    },
    native: function (e, t) {
      const n = t || {};
      return new Promise((t, r) => {
        L.invoke(e, n, (n, i) => {
          if (!(0 === Number(n)))
            return w(e, `${i.errMsg || JSON.stringify(i)}`), void r(i);
          t(i);
        });
      });
    },
    navigateToMiniProgram: function (e) {
      return e.appId
        ? x(d.Native.NAVIGATE_TO_MINI_PROGRAM, e, {
            appId: "",
            path: "",
            params: "",
          })
          ? !e.path && e.params
            ? Y(
                d.Native.NAVIGATE_TO_MINI_PROGRAM,
                e,
                "parameter error: there is params but no path.",
              )
            : L.beforeInvoke(d.Native.NAVIGATE_TO_MINI_PROGRAM, e)
          : e.invalidParamObj
        : Y(
            d.Native.NAVIGATE_TO_MINI_PROGRAM,
            e,
            "parameter error:parameter.appId should be String instead of Undefined.",
          );
    },
    offBluetoothDeviceFound: function () {
      v.off(d.Native.ON_BLUETOOTH_DEVICE_FOUND);
    },
    offScreenRecordingStateChanged: function () {
      v.off(d.Native.ON_SCREEN_RECORD_STATE_CHANGE);
    },
    onBluetoothDeviceFound: function (e) {
      "Function" === H(e)
        ? v.on(d.Native.ON_BLUETOOTH_DEVICE_FOUND, e)
        : w("onBluetoothDeviceFound", "callback is not a function");
    },
    onScreenRecordingStateChanged: function (e) {
      "Function" === H(e)
        ? v.on(d.Native.ON_SCREEN_RECORD_STATE_CHANGE, e)
        : w("onScreenRecordingStateChanged", "callback is not a function");
    },
    openBluetoothAdapter: function (e) {
      return L.beforeInvoke(d.Native.OPEN_BLUETOOTH_ADAPTER, e);
    },
    openDocument: function (e) {
      return (null == e ? void 0 : e.filePath)
        ? e.fileType &&
          -1 ===
            ["doc", "docx", "xls", "xlsx", "ppt", "pptx", "pdf"].indexOf(
              e.fileType,
            )
          ? Y(
              d.Native.OPEN_DOCUMENT,
              e,
              "parameter error:parameter.fileType is invalid value.",
            )
          : L.beforeInvoke(d.Native.OPEN_DOCUMENT, e)
        : Y(
            d.Native.OPEN_DOCUMENT,
            e,
            "parameter error:parameters.filePath should be String instead of Undefined.",
          );
    },
    playAudio: function (e) {
      return e.url
        ? B(e.url)
          ? L.beforeInvoke(d.Native.PLAY_VOICE, e)
          : Y(d.Native.PLAY_AUDIO, e, `parameter error: invalid url ${e.url}`)
        : Y(
            d.Native.PLAY_AUDIO,
            e,
            "parameter error:parameter.url should be String instead of Undefined.",
          );
    },
    previewImage: function (e) {
      return (null == e ? void 0 : e.urls)
        ? L.beforeInvoke(d.Native.PREVIEW_IMAGE, e)
        : Y(
            d.Native.PREVIEW_IMAGE,
            e,
            "parameter error:parameter.urls should be Array instead of Undefined.",
          );
    },
    readBLECharacteristicValue: function (e) {
      return Q(
        {
          deviceId: e.deviceId,
          serviceId: e.serviceId,
          characteristicId: e.characteristicId,
        },
        e,
        d.Native.READ_BLE_CHARACTERISTIC_VALUE,
      ) &&
        x(d.Native.READ_BLE_CHARACTERISTIC_VALUE, e, {
          deviceId: "",
          serviceId: "",
          characteristicId: "",
        })
        ? L.beforeInvoke(d.Native.READ_BLE_CHARACTERISTIC_VALUE, e)
        : e.invalidParamObj;
    },
    removeStorage: function (e) {
      return (null == e ? void 0 : e.key)
        ? L.beforeInvoke(d.Native.REMOVE_STORAGE, e)
        : Y(
            d.Native.REMOVE_STORAGE,
            e,
            "parameter error:parameter.key should be String instead of Undefined.",
          );
    },
    reportEvent: function (e) {
      if (
        J(
          d.Native.REPORT_EVENT,
          e,
          { eventId: "", eventData: {} },
          { eventId: ne, eventData: re },
        )
      ) {
        e.eventData || (e.eventData = {});
        const t = e.eventData;
        for (const n of Object.keys(t)) {
          const r = t[n];
          if (!F(r) && !W(r))
            return Y(
              d.Native.REPORT_EVENT,
              e,
              `parameter error:  invalid value ${r}`,
            );
          W(r) && (t[n] = Number(r.toFixed(6)));
        }
        return L.notifyNative(d.Native.REPORT_EVENT, e);
      }
      return e.invalidParamObj;
    },
    reportLog: function (e) {
      if (!e.log || (!$(e.log) && !F(e.log)))
        return Y(
          d.Native.REPORT_LOG,
          e,
          "parameter error:  parameter.log should be Object or String instead of Undefined.",
        );
      if (e.level && -1 === ["debug", "info", "error"].indexOf(e.level))
        return Y(
          d.Native.REPORT_LOG,
          e,
          `parameter error:  invalid level ${e.level}`,
        );
      $(e.log) && (e.log = JSON.stringify(e.log));
      const t = Object.assign({ level: "info" }, e);
      return L.notifyNative(d.Native.REPORT_LOG, t);
    },
    reportPerformance: function (e) {
      return e.reportEvent && F(e.reportEvent)
        ? e.reportParams && $(e.reportParams)
          ? L.notifyNative(d.Native.REPORT_PERFORMANCE, e)
          : Y(
              d.Native.REPORT_PERFORMANCE,
              e,
              "parameter error:  parameter.reportParams should be Object instead of Undefined.",
            )
        : Y(
            d.Native.REPORT_PERFORMANCE,
            e,
            "parameter error:  parameter.reportEvent should be String instead of Undefined.",
          );
    },
    request: function (e) {
      const t = (function (e) {
        let t = "";
        e.url ||
          (t =
            "parameter error: parameter.url should be String instead of Undefined.");
        B(e.url) || (t = `parameter error: invalid url ${e.url}`);
        e.data &&
          "Function" === H(e.data) &&
          (t = "parameter error: data should not be Function.");
        return t;
      })(e);
      if (t) return Y(d.Native.REQUEST, e, t);
      e.header && !$(e.header) && (e.header = {}),
        (e.header = (function (e) {
          const t = {};
          for (const n in e)
            switch (H(e[n])) {
              case "String":
                t[n] = e[n];
                break;
              case "Number":
              case "Boolean":
                t[n] = `${e[n]}`;
                break;
              default:
                t[n] = JSON.stringify(e[n]);
            }
          return t;
        })(e.header || {}));
      for (const t in e.header)
        if ("content-type" === t.toLowerCase()) {
          const n = e.header[t];
          delete e.header[t], (e.header[t.toLowerCase()] = n);
        }
      (e.method = e.method ? e.method.toUpperCase() : "GET"),
        (e.dataType = e.dataType || "json"),
        (e.header["content-type"] =
          e.header["content-type"] || "application/json");
      let n = "";
      e.data && (n = $(e.data) ? JSON.stringify(e.data) : e.data),
        "GET" === e.method && (e.url = V(e.url, e.data || {}));
      const r = Object.assign({ data: n }, e);
      return L.beforeInvoke(d.Native.REQUEST, r, {
        beforeSuccess(t) {
          if ("json" === e.dataType)
            try {
              t.data && F(t.data) && (t.data = JSON.parse(t.data));
            } catch (t) {
              w(d.Native.REQUEST, `JSON parse data error from ${e.url}`);
            }
        },
      });
    },
    saveBase64Image: function (e) {
      return e.base64
        ? x(d.Native.SAVE_BASE64_IMAGE, e, { base64: "" })
          ? L.beforeInvoke(d.Native.SAVE_BASE64_IMAGE, e)
          : e.invalidParamObj
        : Y(
            d.Native.SAVE_BASE64_IMAGE,
            e,
            "parameter error:parameter.base64 should be String instead of Undefined.",
          );
    },
    saveFileToPhone: function (e) {
      return e.content
        ? e.fileName
          ? x(d.Native.SAVE_FILE_TO_PHONE, e, { content: "", fileName: "" })
            ? L.beforeInvoke(d.Native.SAVE_FILE_TO_PHONE, e)
            : e.invalidParamObj
          : Y(
              d.Native.SAVE_FILE_TO_PHONE,
              e,
              "parameter error:parameter.fileName should be String instead of Undefined.",
            )
        : Y(
            d.Native.SAVE_FILE_TO_PHONE,
            e,
            "parameter error:parameter.content should be String instead of Undefined.",
          );
    },
    saveImage: function (e) {
      return e.content
        ? x(d.Native.SAVE_IMAGE, e, { content: "" })
          ? L.beforeInvoke(d.Native.SAVE_IMAGE, e)
          : e.invalidParamObj
        : Y(
            d.Native.SAVE_IMAGE,
            e,
            "parameter error:parameter.content should be String instead of Undefined.",
          );
    },
    scanCode: function (e) {
      const t = ["barCode", "qrCode", "datamatrix", "pdf417"];
      if (
        (null == e ? void 0 : e.scanType) &&
        e.scanType.length > 0 &&
        !e.scanType.every((e) => t.indexOf(e) > -1)
      )
        return Y(
          d.Native.SCAN_CODE,
          e,
          "parameter error:parameter.scanType contains invalid values.",
        );
      const n = Object.assign(
        { onlyFromCamera: !1, scanType: ["barCode", "qrCode"] },
        e,
      );
      return L.beforeInvoke(d.Native.SCAN_CODE, n);
    },
    setStorage: function (e) {
      if (!(null == e ? void 0 : e.key) || !e.data)
        return Y(
          d.Native.SET_STORAGE,
          e,
          "parameter error:parameter.key or parameter.data should not be Undefined.",
        );
      const t = Object.assign({ encrypt: !1 }, e);
      return L.beforeInvoke(d.Native.SET_STORAGE, t);
    },
    setStorageSync: function (e, t) {
      return "String" !== H(e)
        ? Y(
            d.Native.SET_STORAGE_SYNC,
            {},
            `parameter error:key should be string instead of ${typeof e}.`,
          )
        : L.invokeSync(d.Native.SET_STORAGE_SYNC, { key: e, data: t });
    },
    showLoading: function (e) {
      const t = Object.assign({ title: "Loading...", mask: !1 }, e);
      return x(d.Native.SHOW_LOADING, t, { title: "", mask: !1 })
        ? L.beforeInvoke(d.Native.SHOW_LOADING, t)
        : t.invalidParamObj;
    },
    showToast: function (e) {
      var t;
      if (!(null == e ? void 0 : e.title) && !(null == e ? void 0 : e.message))
        return Y(
          d.Native.SHOW_TOAST,
          e,
          "parameter error: prompt message should be String instead of Undefined.",
        );
      if (
        ((e.title = null !== (t = e.title) && void 0 !== t ? t : e.message),
        x(d.Native.SHOW_TOAST, e, {
          title: "",
          message: "",
          icon: "",
          duration: 0,
          mask: !1,
          image: "",
        }))
      ) {
        const t = ["success", "error", "loading", "none"];
        if (
          (null == e ? void 0 : e.icon) &&
          -1 === t.indexOf(null == e ? void 0 : e.icon)
        )
          return Y(
            d.Native.SHOW_TOAST,
            e,
            "parameter error:parameter.icon contains invalid values.",
          );
        const n = Object.assign(
          { icon: "success", duration: 1500, mask: !1 },
          e,
        );
        return L.beforeInvoke(d.Native.SHOW_TOAST, n);
      }
      return e.invalidParamObj;
    },
    startBluetoothDevicesDiscovery: function (e) {
      return J(
        d.Native.START_BLUETOOTH_DEVICES_DISCOVERY,
        e,
        { services: ["1"] },
        { services: { optional: !0 } },
      )
        ? L.beforeInvoke(d.Native.START_BLUETOOTH_DEVICES_DISCOVERY, e)
        : e.invalidParamObj;
    },
    stopAudio: function (e) {
      return L.beforeInvoke(d.Native.STOP_AUOID, e);
    },
    stopBluetoothDevicesDiscovery: function (e) {
      return L.beforeInvoke(d.Native.STOP_BLUETOOTH_DEVICES_DISCOVERY, e);
    },
    submitReport: function (e) {
      return L.beforeInvoke(d.Native.SUBMIT_REPORT, e);
    },
    tradePay: function (e) {
      return J(
        d.Native.TRADE_PAY,
        e,
        { tradeNO: "", orderStr: "", sign: "", extendParam: "" },
        { tradeNO: oe, orderStr: oe, sign: oe, extendParam: ae },
      )
        ? L.beforeInvoke(d.Native.TRADE_PAY, e)
        : e.invalidParamObj;
    },
    uploadFile: function (e) {
      if (!e.url)
        return Y(
          d.Native.UPLOAD_FILE,
          e,
          "parameter error: parameter.url should be String instead of Undefined.",
        );
      if (e.files) (e.filePath = ""), (e.name = "");
      else {
        if (!e.filePath)
          return Y(
            d.Native.UPLOAD_FILE,
            e,
            "parameter error: parameter.filePath should be String instead of Undefined.",
          );
        if (!e.name)
          return Y(
            d.Native.UPLOAD_FILE,
            e,
            "parameter error: parameter.name should be String instead of Undefined.",
          );
      }
      return L.beforeInvoke(d.Native.UPLOAD_FILE, e);
    },
    writeBLECharacteristicValue: function (e) {
      const {
          deviceId: t,
          serviceId: n,
          characteristicId: r,
          value: i,
          writeType: o,
        } = e,
        a = { deviceId: t, serviceId: n, characteristicId: r, value: i };
      if (
        (void 0 !== o && (a.writeType = o),
        !Q(a, e, d.Native.WRITE_BLE_CHARACTERISTIC_VALUE))
      )
        return e.invalidParamObj;
      if (
        x(d.Native.WRITE_BLE_CHARACTERISTIC_VALUE, e, {
          deviceId: "",
          serviceId: "",
          characteristicId: "",
          value: new ArrayBuffer(8),
          writeType: "",
        })
      ) {
        const t = ["write", "writeNoResponse", "signedWrite"];
        if (
          (null == e ? void 0 : e.writeType) &&
          -1 === t.indexOf(null == e ? void 0 : e.writeType)
        )
          return Y(
            d.Native.WRITE_BLE_CHARACTERISTIC_VALUE,
            e,
            "parameter error:parameter.writeType contains invalid values.",
          );
        const n = ((s = e.value), Array.from(new Uint8Array(s))),
          r = Object.assign(Object.assign({}, e), { value: n });
        return L.beforeInvoke(d.Native.WRITE_BLE_CHARACTERISTIC_VALUE, r);
      }
      var s;
      return e.invalidParamObj;
    },
  });
  const ce = Object.assign(
    {
      miniProgram: Object.assign(Object.assign({}, ee), {
        navigateBackMiniProgram() {},
        onWebviewEvent() {},
        offWebviewEvent() {},
        sendWebviewEvent() {},
        onShow() {},
        onHide() {},
        onUnload() {},
      }),
    },
    se,
  );
  return (
    "loading" !== document.readyState
      ? P()
      : document.addEventListener("DOMContentLoaded", P),
    (window.onerror = function (e, t, n, r, i) {
      U.normalError({
        key: "thirdPageParamsError",
        message: e,
        file: t,
        line: n,
        column: r,
      });
    }),
    (window.ma = ce),
    (window.viewLayer = {
      onInvokeFinished: function (e, t, n) {
        const r = _[e];
        "function" == typeof r && r(t, n), 2 !== Number(t) && delete _[e];
      },
      subscribeHandler: function (e, t) {
        return (0, g[e])(t);
      },
    }),
    ce
  );
});
